import { AfterViewInit, Directive, Host, Input } from '@angular/core';

import { TwcInputFileComponent, TwcInputFileZoneComponent } from '@topcon/twc-angular';

/**
 * Directive to enable dropping directories in a TwcInputFileComponent
 * TODO: We should suggest TWC to add this functionality taking in account browser compatibility
 */
@Directive({
    selector: 'twc-input-file[cwEnableDirectoryDrop]',
    standalone: false,
})
export class EnableDirectoryDropDirective implements AfterViewInit {
    /** Input to be able to toggle the enable directory functionality, to set it off pass a real false not a falsy value */
    @Input() cwEnableDirectoryDrop: '' | boolean | undefined = true;

    constructor(@Host() private inputFile: TwcInputFileComponent) {}

    async ngAfterViewInit(): Promise<void> {
        if (this.cwEnableDirectoryDrop === false || !this.inputFileZone) {
            return;
        }

        // Rewrites onDrop function in the intanced TwcInputFileZoneComponent to enable directory handling
        this.inputFileZone.onDrop = async function (this: TwcInputFileZoneComponent, event: DragEvent): Promise<void> {
            (this as any).preventDefault(event);
            this.dragStatus = 'noDrag';
            if (!event.dataTransfer) {
                return;
            }

            const fileItems = Array.from(event.dataTransfer.items).filter((item) => item.kind === 'file');
            // Using webkitGetAsEntry as in V1 because is more supported than modern DataTransferItem.getAsFileSystemHandle()
            const fileEntries = fileItems.map((fileItem) => fileItem.webkitGetAsEntry()).filter(Boolean) as FileSystemEntry[];

            // Recursive function to return files and files inside directories
            const parseEntries = async (entries: FileSystemEntry[]): Promise<File[]> => {
                const files = await Promise.all(
                    entries.map(async (entry) => {
                        if (entry.isDirectory) {
                            const directoryReader = (entry as FileSystemDirectoryEntry).createReader();
                            const readEntries = (): Promise<FileSystemEntry[]> =>
                                new Promise((resolve, reject) => {
                                    directoryReader.readEntries(resolve, reject);
                                });
                            const nestedEntries = await readEntries();
                            return await parseEntries(nestedEntries);
                        } else if (entry.isFile) {
                            const file = await new Promise<File>((resolve, reject) => {
                                (entry as FileSystemFileEntry).file(resolve, reject);
                            });
                            return file;
                        }
                        return null;
                    })
                );

                return files.flat().filter(Boolean) as File[];
            };

            const files = await parseEntries(fileEntries);

            // Make File[] behave as FileList
            (files as any).item = (index: number): File => files[index];

            (this as any).addFiles(files);
        }.bind(this.inputFileZone);
    }

    /**
     * Gets the TwcInputFileZoneComponent from the TwcInputFileComponent
     */
    get inputFileZone(): TwcInputFileZoneComponent | undefined {
        return this.inputFile.zoneComponent;
    }
}
